/**
 * aswbe checkin eapi
 * チェックイン業務で利用するAPIを提供する
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

export interface PostJourneysSearchJourneyRequest {
  /**
   * 検索方法<br> amcMember:AMC会員 order:予約 eTicket:航空券
   */
  searchType: PostJourneysSearchJourneyRequest.SearchTypeEnum;
  /**
   * 予約番号 (半角英数字6桁)
   */
  orderId?: string;
  /**
   * 搭乗者名 (半角英字空白1-55桁)
   */
  firstName: string;
  /**
   * 搭乗者姓 (半角英字空白2-55桁)
   */
  lastName: string;
  /**
   * 航空券番号 (半角数字13桁)
   */
  eTicketNumber?: string;
  /**
   * 遷移元が予約詳細画面であるかどうか。指定なしの場合、falseとする。
   */
  transitionedFromServicing?: boolean;
}
export namespace PostJourneysSearchJourneyRequest {
  export type SearchTypeEnum = 'amcMember' | 'order' | 'eTicket';
  export const SearchTypeEnum = {
    AmcMember: 'amcMember' as SearchTypeEnum,
    Order: 'order' as SearchTypeEnum,
    ETicket: 'eTicket' as SearchTypeEnum,
  };
}
